/**
 * @fileoverview What every share button in Grow shares besides its look:
 * its size, and whether the browser has a share menu for a link.
 *
 * Used by: ShareButtons (Share, Copy link, LinkShareRow), SharePlantDialog's
 * bar (the size of Save picture and Copy picture), GardenPageRow (Change, in
 * the link's row) and GiftThanksPage (Copy code and Print, in the link's row).
 *
 * @module shareLink
 */

/** Every share button's height and padding: a thumb tall, as in the share sheet's bar. */
export const SHARE_BUTTON_CLASS = 'h-11 whitespace-nowrap px-3';

/**
 * Whether this browser has a share menu that takes a link.
 *
 * @returns True where navigator.share exists.
 */
export function canShareLink(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}
